<div class="aside has-header has-footer has-margin-icon">

    <div class="aside-header">
        <div class="row">
            <div class="col-auto">
                <i class="header-icon icon-home"></i>
            </div>
            <div class="col">
                <div class="title title-bg">
                    <h2 class="title-main">{{'OFFER_CONFIG.WELTH' | translate}}</h2>
                </div>
            </div>
        </div>
    </div>

    <div class="aside-content">
        <div class="aside-content-body">
            <div class="section" *ngIf="product.configuration.configurationStep === propertyConfigurationStep.BASIC">
                <div class="section-content">
                    <div class="separator"></div>

                    <h3 class="page-subheader">{{'OFFER_CONFIG.POLICY_DATA' | translate}}</h3>

                    <div class="row form-row">
                        <div class="col-4">
                            <app-select [(ngModel)]="continuation"
                                        [itemList]="(dictionaries$|async)[dictionaryTypes.CALCULATION_SUBJECT].itemList"
                                        [hasEmpty]="false"
                                        [errorStateMatcher]="matchers.continuation"
                                        [label]="'OFFER_CONFIG.TYPE_OF_POLICY' | translate">
                            </app-select>
                        </div>
                    </div>

                    <div class="row form-row" *ngIf="continuation === calculationSubject.CONTINUATION">
                        <div class="col-4">
                            <app-input [label]="'OFFER_CONFIG.LAST_YEAR_POLICY_NR' | translate"
                                       [errorStateMatcher]="matchers.previousPolicyNumber"
                                       [(ngModel)]="product.configuration.continuation.policyNumber">
                            </app-input>

                        </div>
                    </div>

                    <div class="separator"></div>

                    <h3 class="page-subheader">{{ 'INSURANCE_PERIOD' | translate }}</h3>

                    <div class="row form-row">
                        <div class="col-4">
                            <app-datepicker [ngModel]="product.configuration.insuranceStartDate"
                                            (ngModelChange)="insuranceStartDate = $event"
                                            [errorStateMatcher]="matchers.insuranceStartDate"
                                            [minToday]="true"
                                            [label]="'OFFER_CONFIG.INSURANCE_DATE_FROM' | translate">
                            </app-datepicker>
                        </div>
                        <div class="col-4">
                            <app-datepicker [(ngModel)]="product.configuration.insuranceEndDate"
                                            [disabled]="true"
                                            [errorStateMatcher]="matchers.insuranceEndDate"
                                            [label]="'OFFER_CONFIG.INSURANCE_DATE_TO' | translate">
                            </app-datepicker>
                        </div>
                    </div>

                    <div class="separator"></div>

                    <h3 class="page-subheader">{{'OFFER_CONFIG.ESTATE_DATA' | translate}}</h3>


                    <div class="row form-row">
                        <div class="col-4">
                            <app-select [ngModel]="product.configuration.propertyType?.code"
                                        (ngModelChange)="propertyType = $event"
                                        [itemList]="(dictionaries$|async)[dictionaryTypes.PROPERTY_TYPE].itemList"
                                        [errorStateMatcher]="matchers.propertyType"
                                        [label]="'OFFER_CONFIG.ESTATE_TYPE' | translate">
                            </app-select>
                        </div>
                    </div>

                    <app-address-form [address]="product.configuration.address"
                                      [aside]="true"
                                      [disableApartment]="product.configuration.propertyType?.code === propertyTypes.HOUSE"
                                      prefix="address">
                    </app-address-form>

                    <div class="separator"></div>

                    <h3 class="page-subheader">{{'OFFER_CONFIG.ADDITIONAL_ESTATE_PROPERTIES' | translate}}</h3>

                    <ul class="list-unstyled">
                        <li *ngFor="let value of attributes">
                            <mat-checkbox [(ngModel)]="product.configuration.propertyAttributeMap[value.type]">
                                {{ value.label | translate}}
                            </mat-checkbox>
                        </li>
                    </ul>

                    <app-message-box *ngIf="matchers.calculation.errors.length > 0"
                                     [errorStateMatcher]="matchers.calculation"></app-message-box>
                </div>
            </div>

            <!-- step2 -->
            <div class="section" *ngIf="product.configuration.configurationStep === propertyConfigurationStep.DETAILS">
                <div class="section-content">
                    <div class="separator"></div>

                    <h3 class="page-subheader">{{ 'OFFER_CONFIG.INSURANCE_COVERAGE' | translate }}</h3>

                    <div class="row form-row mt-2" *ngIf="matchers.elementListMatcher.errors.length > 0">
                        <div class="col">
                            <app-message-box [errorStateMatcher]="matchers.elementListMatcher"></app-message-box>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="col size-property-col-1"></div>
                        <div class="col-auto size-property-col-2">{{'OFFER_CONFIG.FIRE_RANDOM_EVENTS' | translate}}</div>
                        <div class="col-auto size-property-col-3">{{'OFFER_CONFIG.THEFT' | translate}}</div>
                        <div class="col-2 text-right">{{'OFFER_CONFIG.PREMIUM' | translate}}</div>
                    </div>

                    <div class="row form-row" *ngFor="let element of elements">
                        <div class="col-auto size-property-col-1 form-label-checkbox-sm">
                            <mat-checkbox [ngModel]="product.configuration.elementList[element.type].selected"
                                          (ngModelChange)="setElementSelected(element.type, $event)">
                                {{ element.label | translate}}
                            </mat-checkbox>
                        </div>

                        <div class="col-auto size-property-col-2">
                            <app-numeric [(ngModel)]="product.configuration.elementList[element.type].fire"
                                         [slim]="true"
                                         [errorStateMatcher]="matchers.elementList[element.type].fire"
                                         [disabled]="!product.configuration.elementList[element.type].selected"
                                         [suffix]="'LABEL.SUFFIX_PLN' | translate">
                            </app-numeric>
                        </div>

                        <div class="col-auto size-property-col-3">
                            <app-numeric [(ngModel)]="product.configuration.elementList[element.type].theft"
                                         [slim]="true"
                                         [errorStateMatcher]="matchers.elementList[element.type].theft"
                                         [disabled]="!product.configuration.elementList[element.type].selected"
                                         [suffix]="'LABEL.SUFFIX_PLN' | translate">
                            </app-numeric>
                        </div>
                        <div class="col-2 text-right form-label-static-sm">
                            <span>{{ product.configuration.elementList[element.type].premium | premium }}</span>
                        </div>
                    </div>


                    <div class="row form-row">
                        <div class="col-auto size-property-col-1 form-label-checkbox-sm">
                            <mat-checkbox [disabled]="!hasMainInsurance"
                                          [(ngModel)]="product.configuration.floodRisk.selected">
                                {{'OFFER_CONFIG.FLOOD_RISK' | translate}}
                            </mat-checkbox>
                        </div>
                        <div class="col-auto size-property-col-double">
                            <app-select [ngModel]="product.configuration.floodRisk.claims?.code"
                                        *ngIf="product.configuration.floodRisk.selected"
                                        [slim]="true"
                                        (ngModelChange)="product.configuration.floodRisk.claims = {code: $event}"
                                        [itemList]="(dictionaries$|async)[dictionaryTypes.FLOOD_CLAIMS].itemList"
                                        [placeholder]="'LABEL.PICK' | translate"
                                        [errorStateMatcher]="matchers.floodRisk.claims">
                            </app-select>
                        </div>
                        <div class="col-2 text-right form-label-static-sm">
                            <span>{{ product.configuration.floodRisk.premium | premium }}</span>
                        </div>
                    </div>

                    <hr/>

                    <div class="row form-row">
                        <div class="col-auto size-property-col-1 form-label-checkbox-sm">
                            <mat-checkbox [disabled]="!hasMainInsurance"
                                          [(ngModel)]="product.configuration.homeAssistance.selected">
                                {{'OFFER_CONFIG.HOME_ASSISTANCE' | translate}}
                            </mat-checkbox>
                        </div>
                        <div class="col-auto size-property-col-double text-right form-label-static-sm"
                             *ngIf="product.configuration.homeAssistance.selected">
                            {{ product.configuration.homeAssistance.sumOfInsurance | premium }}
                        </div>

                        <div class="col-2 text-right form-label-static-sm"
                             *ngIf="product.configuration.homeAssistance.selected">
                            <span>{{ product.configuration.homeAssistance.premium | premium }}</span>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="col-4 form-label-checkbox-sm">
                            <mat-checkbox [disabled]="!hasMainInsurance"
                                          [(ngModel)]="product.configuration.personalLiability.selected">
                                {{ 'OFFER_CONFIG.OC_PERSONAL' | translate }}
                            </mat-checkbox>
                        </div>
                    </div>


                    <div class="row form-row" *ngIf="product.configuration.personalLiability.selected">
                        <div class="col-auto size-property-col-1 form-label-static-sm">{{'OFFER_CONFIG.INSURED_NUMBER' | translate}}</div>
                        <div class="col-auto size-property-col-2">
                            <app-select [ngModel]="product.configuration.personalLiability.insuredPersonCount?.code"
                                        [slim]="true"
                                        [minSizeForFilter]="null"
                                        [placeholder]="'LABEL.PICK' | translate"
                                        (ngModelChange)="product.configuration.personalLiability.insuredPersonCount = {code: $event}"
                                        [itemList]="(dictionaries$|async)[dictionaryTypes.NUMBER_OF_INSURED].itemList"
                                        [errorStateMatcher]="matchers.personalLiability.insuredPersonCount">
                            </app-select>

                        </div>
                        <div class="col-auto size-property-col-3 text-right form-label-static-sm">
                            {{ 'SUM_INSURED_200000' | translate }}
                        </div>

                        <div class="col-2 text-right form-label-static-sm">
                            {{ product.configuration.personalLiability.premium | premium }}
                        </div>
                    </div>


                    <div class="separator"></div>

                    <div class="row">
                        <div class="col">
                            <h3 class="page-subheader">{{'OFFER_CONFIG.PAYMENTS' | translate}}</h3>
                        </div>
                        <div class="col-auto size-half-insurance h3 page-subheader">
                            <!--        Wysokość i termin płatności raty-->
                        </div>
                    </div>


                    <div class="row form-row">
                        <div class="col-auto size-property-col-1">
                            <app-select [ngModel]="product.configuration.paymentDefinition.installments?.code"
                                        [label]="'OFFER_CONFIG.INSTALLMENTS' | translate"
                                        [hasEmpty]="false"
                                        (ngModelChange)="product.configuration.paymentDefinition.installments = {code: $event}"
                                        [itemList]="(dictionaries$|async)[dictionaryTypes.INSTALLMENTS].itemList"
                                        [errorStateMatcher]="matchers.paymentDefinition.installments">
                            </app-select>
                        </div>

                        <div class="col-auto size-property-col-2">
                            <app-select
                                    [ngModel]="product.configuration.paymentDefinition.deferredPayment?.code"
                                    [label]="'OFFER_CONFIG.DEFERMENT' | translate"
                                    [hasEmpty]="false"
                                    (ngModelChange)="product.configuration.paymentDefinition.deferredPayment = {code: $event}"
                                    [itemList]="(dictionaries$|async)[dictionaryTypes.DEFERRED_PAYMENT].itemList"
                                    [errorStateMatcher]="matchers.paymentDefinition.deferredPayment">
                            </app-select>
                        </div>

                        <div class="col-auto size-half-insurance">
                            <div class="row" *ngIf="product.configuration.paymentDefinition.installmentList">
                                <div class="col-3"
                                     *ngFor="let element of product.configuration.paymentDefinition.installmentList">
                                    <!--                                            {{ 'OFFER_CONFIG.DATE_OF_PAYMENT' | translate }}-->
                                    <div class="inst">
                                        <div class="item-amount">{{ element.amount | premium }}</div>
                                        <div class="item-date">{{ element.date | lsnDate }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <app-message-box *ngIf="matchers.calculation.errors.length > 0"
                                     [errorStateMatcher]="matchers.calculation"></app-message-box>

                    <div class="separator"></div>

                    <hr/>

                    <div class="separator"></div>

                    <div class="row" *ngIf="product.configuration.premium !== null">
                        <div class="col">
                            {{ 'OFFER_CONFIG.TOTAL_PREMIUM' | translate }}
                        </div>
                        <div class="col-auto">
                            <div class="text-price">
                                <div class="item-price">
                                    {{ product.configuration.premium | premium }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="aside-footer">
        <div class="footer-btn-left">
            <button *ngIf="product.configuration.configurationStep === propertyConfigurationStep.DETAILS"
                    (click)="back()"
                    class="btn btn-secondary"
                    type="button">{{ 'BUTTON.BACK' | translate }}</button>
        </div>


        <div class="footer-btn">
            <button (click)="close()" class="btn btn-secondary"
                    type="button">{{ 'BUTTON.CANCEL' | translate }}</button>

            <button *ngIf="product.configuration.configurationStep === propertyConfigurationStep.BASIC"
                    (click)="next()"
                    class="btn btn-primary"
                    type="button">
                {{ 'BUTTON.NEXT' | translate }}
            </button>

            <button
                    *ngIf="product.configuration.configurationStep === propertyConfigurationStep.DETAILS && !productCalculated"
                    (click)="calculate()"
                    class="btn btn-primary"
                    type="button">
                {{ 'BUTTON.CALCULATE' | translate }}
            </button>

            <button
                    *ngIf="product.configuration.configurationStep === propertyConfigurationStep.DETAILS && productCalculated"
                    (click)="save()"
                    class="btn btn-primary"
                    type="button">
                {{ 'BUTTON.SAVE' | translate }}
            </button>
        </div>
    </div>
</div>
